import { createFileRoute } from '@tanstack/react-router'
import { CreateCustomer } from '../../../pages/CreateCustomer'

export const Route = createFileRoute('/helpdesk/customers/new')({
  component: CreateCustomer,
})